import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/login/Login';
import Dashboard from '../pages/dashboard/Dashboard';
import Report from '../pages/Reports/Report';
import ProtectedRoute from '../components/ProtectedRoute';
import Analytics from '../pages/analytics/Analytics';
import Alerts from '../pages/alerts/Alerts';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route 
                path="/dashboard" 
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/alerts" 
                element={
                    <ProtectedRoute>
                        <Alerts />
                    </ProtectedRoute>
                } 
            />
             <Route 
                path="/analytics" 
                element={
                    <ProtectedRoute>
                        <Analytics />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/reports" 
                element={
                    <ProtectedRoute>
                        <Report />
                    </ProtectedRoute>
                } 
            />
        </Routes>
    );
};

export default AppRoutes;
